<template>
  <div>
   
    <v-row class="ma-4">
      <v-col md="11" sm="12">
        <v-textarea :label ="label" v-model="formula.script" outlined rows="3">
        </v-textarea>

        <div
          class="text-body-1"
          :class="`blue-grey--text text--darken-2`"
          label="Campos"
        >
          Imagens:
        </div>

        <v-row class="ma-1">
          <div class="text-center" label="images">
            <v-chip
              v-for="(image, indexImage) in formula.images"
              :key="indexImage"
              class="ma-2"
              close
              @click:close="deleteImage( indexImage)"
              large
              style="height: 60px;"
            >
              <v-text-field
             
                label="Descrição"
                v-model="image.description"
              ></v-text-field>
              <v-text-field style=""
                label="URL"
                v-model="image.url"
              ></v-text-field>
            </v-chip>
            <v-btn
              class="secondary"
              @click="addImage()"
              style="border-radius: 25px"
              >+</v-btn
            >
          </div>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
        </v-row>
      </v-col>
      <v-col md="1" sm="12">
        <v-btn class="primary" @click="testFormula()">Teste</v-btn>
      </v-col>
    </v-row>
 
  </div>
</template>

<script>
export default {
  name: "edit-formula-document",
  props: ["formula", "images", "object", "label"], // object: quote, product ...
  components: {},
  data() {
    return {
      dialogimage: false,
      quote: {
        cost: 100,
        price: 100,
        images: [
          // {"default":false,"object":"quote","id":"zwH8AtIaHusqdZjeMNDY","type":"","description":"Margem (%)",value:0}
        ],
      },

      solarPlant:{
        dcPower:100,
        nModules:100,
      },
      product:{
        cost:100,
        price:100,
      }
    };
  },
  methods: {
    testFormula() {
      var formula = this.formula;
      var images = formula.images;
      var script = formula.script;
      this.quote.images = [];

      var f = 0;
      //When the user creates a quote
      for (f = 0; f < images.length; f++) {
        var image = images[f];
        if (!image.default) {
          this.quote.images.push(image);
        }
      }
      // var quote = this.quote;
      // var product = this.procuct;
      // var solarPlant= this.solarPlant;

      for (f = 0; f < images.length; f++) {
        var image = images[f];
        if (image.default) {
          script = script.replaceAll(`[${image.description}]`, image.id);
        } else {
          var selimage = this.quote.images.find(
            (element) => element.id == image.id
          );
          this.quote.images.push(image);
          script = script.replaceAll(
            `[${selimage.description}]`,
            selimage.value
          );
        }
      }
      script = script.replaceAll("quote.", "this.quote.");
      script = script.replaceAll("product.", "this.product.");
      script = script.replaceAll("solarPlant.", "this.solarPlant.");
      
      alert(script);
      try {
        eval(script);

        alert(
          `OK-  Custo: ${this.quote.price},   Preço: ${ this.quote.price
          }, Campos: ${JSON.stringify(this.quote.images)} ,
          
          Custo produto: ${this.product.cost},   Preço: ${  this.product.price },

          Potência Dc: ${this.solarPlant.dcPower},  Número de módulos: ${ this.solarPlant.nModules},
          `
        );
      } catch (e) {
        alert(e);
        if (e instanceof SyntaxError) {
          alert(e);
        }
      }
    },
    openDialogimage() {
      this.dialogimage = true;
    },
    deleteImage(indexImage) {
      //alert(indexImage);
      this.formula.images.splice(indexImage, 1);
      this.$forceUpdate();
    },
    addImage(indexImage) {
   
      this.formula.images.push({description:"", url:""});
     // this.dialogimage = false;
    },
  },
};
</script>
